import { useMemo } from 'react';

import { Select } from '@components/Select';
import { useRingtones } from '@hooks/useRingtones';

interface ICallPreferencesRingTonesSelectorProps {
  defaultSelected?: string;
  onChange: (event: unknown) => void;
  width?: string;
}
export function CallPreferencesRingTonesSelector({
  defaultSelected,
  onChange,
  width,
}: ICallPreferencesRingTonesSelectorProps) {
  const ringtones = useRingtones();

  const options = useMemo(
    () =>
      ringtones ? ringtones.map((item) => ({ label: item.friendlyName, value: item.name })) : [],
    [ringtones]
  );
  return (
    <Select
      width={width}
      name='currentRingtone'
      onChange={onChange}
      value={defaultSelected}
      data-test='user-profile-call-ringtone-select'
      placeholder=''
      options={options}
    />
  );
}
